import { render, staticRenderFns } from "./block-header.vue?vue&type=template&id=75f71533&scoped=true"
import script from "./block-header.vue?vue&type=script&lang=js"
export * from "./block-header.vue?vue&type=script&lang=js"
import style0 from "./block-header.vue?vue&type=style&index=0&id=75f71533&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f71533",
  null
  
)

export default component.exports